module.exports = __webpack_public_path__ + "static/media/tj.0db28cf0.svg";